import React, {useState, useEffect} from 'react';

const TextLikeField = ({
                         type,
                         inputProps,
                         id,
                         noMargin,
                         label,
                         placeholder,
                         helpBlock,
                         valueToString,
                         stringToValue,
                         valueValidator,
                         value,
                         onChange
                       }) => {

  const [_value, setValue] = useState(valueToString ? valueToString(value) : value);

  useEffect(() => {
    const convertedValue = stringToValue ? stringToValue(_value) : _value;
    onChange(valueValidator && !valueValidator(convertedValue) ? null : convertedValue);
  }, [_value]);

  return <div className={noMargin ? '' : 'mb-3'}>
    {label && <label htmlFor={id} className="form-label">{label}</label>}
    <input {...(inputProps || {})}
           type={type}
           id={id}
           className="form-control"
           placeholder={placeholder}
           value={_value || ''}
           onChange={e => setValue(e.target.value)}/>
    {helpBlock && <div className="form-text">{helpBlock}</div>}
  </div>
};

const TextField = props => <TextLikeField {...props} type="text"/>;
export {TextField};

const IntegerField = ({min, max, step, ...props}) => {
  const integerToString = i => {
    if (i == null) {
      return null;
    } else {
      return '' + i;
    }
  };
  const stringToInteger = s => {
    if (!s) {
      return null;
    } else {
      return Math.round(parseFloat(s));
    }
  };
  return <TextLikeField {...props}
                        type="number"
                        inputProps={{min, max, step}}
                        valueToString={integerToString}
                        stringToValue={stringToInteger}/>;
};
export {IntegerField};

const FloatField = ({min, max, step, ...props}) => {
  const floatToString = f => {
    if (f == null) {
      return null;
    } else {
      return '' + f;
    }
  };
  const stringToFloat = s => {
    if (!s) {
      return null;
    } else {
      return parseFloat(s);
    }
  };
  return <TextLikeField {...props}
                        type="number"
                        inputProps={{min, max, step}}
                        valueToString={floatToString}
                        stringToValue={stringToFloat}/>;
};
export {FloatField};

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const EmailField = props => <TextLikeField {...props}
                                           type="email"
                                           valueValidator={v => !v || emailRegex.test(v)}/>;
export {EmailField};

const PasswordField = props => <TextLikeField {...props} type="password"/>;
export {PasswordField};
